import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAgentCoPilotBackground = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 1200,
	height: 323,
	viewBox: "0 0 1200 323",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_2041_20915",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: -621,
			y: 44,
			width: 2178,
			height: 894,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M324.637 63.5226C425.342 49.0455 533.449 42.1544 644.843 44.4259C756.237 46.6974 861.082 57.8587 958.402 76.1085C1221.23 125.52 1424.37 228.315 1510.58 354.376C1542.31 400.438 1558.59 449.751 1556.32 500.918C1554.06 552.085 1533.42 601.014 1497.65 646.371C1467.07 685.554 1424.65 722.139 1373.06 755.387C1260.68 827.076 1103.98 882.775 921.34 912.863L916.709 913.617C819.336 929.345 714.323 938.022 605.265 937.976L-620.631 937.382C-612.599 933.397 -604.733 929.243 -597.036 925.003C-501.39 873.872 -429.601 813.447 -389.559 747.147C-367.193 710.693 -354.95 672.513 -353.205 633.114L-346.466 480.978C-344.138 428.427 -322.663 378.308 -285.111 331.811L-283.311 329.6C-211.734 242.213 -83.2564 168.474 79.5479 117.787C104.456 110.049 129.955 102.916 156.483 96.3234L161.804 95.0128C211.753 82.723 264.426 72.3032 319.317 64.2911L324.637 63.5226ZM-620.631 937.382C-620.688 937.41 -620.745 937.44 -620.802 937.468L-620.798 937.382H-620.631ZM641.501 208.275C538.894 206.182 439.705 212.549 347.956 225.738L347.876 225.749L347.796 225.761C296.414 233.096 247.289 242.75 200.958 254.15L200.843 254.178L200.728 254.205C175.529 260.367 151.552 267.027 128.263 274.261L128.264 274.262C-20.0668 320.442 -113.83 381.315 -156.527 433.444L-156.623 433.56C-177.926 459.519 -182.27 477.517 -182.744 488.23L-189.482 640.366C-191.558 687.222 -202.084 731.888 -219.526 773.693L605.337 774.092C707.34 774.135 805.017 765.883 894.701 751.159C1061.97 723.603 1195.9 673.922 1284.6 617.43C1325.2 591.228 1352.18 566.401 1368.45 545.55L1368.71 545.215L1368.97 544.882C1388.15 520.568 1392.16 503.69 1392.6 493.667C1393.02 484.159 1390.81 469.393 1375.62 447.335L1375.46 447.113L1375.31 446.891C1326.44 375.436 1177.5 284.052 928.123 237.17V237.169C839.865 220.623 744.034 210.365 641.501 208.275Z",
				fill: "url(#paint0_linear_2041_20915)"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_2041_20915)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: -688.207,
					y: -665.085,
					width: 2312.15,
					height: 2312.15,
					rx: 202.758,
					fill: "url(#paint1_linear_2041_20915)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: -688.207,
					y: -665.085,
					width: 2312.15,
					height: 2312.15,
					rx: 202.758,
					fill: "url(#paint2_radial_2041_20915)",
					fillOpacity: .9
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: -688.207,
					y: -665.085,
					width: 2312.15,
					height: 2312.15,
					rx: 202.758,
					fill: "url(#paint3_radial_2041_20915)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: -688.207,
					y: -665.085,
					width: 2312.15,
					height: 2312.15,
					rx: 202.758,
					fill: "url(#paint4_radial_2041_20915)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: -688.207,
					y: -665.085,
					width: 2312.15,
					height: 2312.15,
					rx: 202.758,
					fill: "url(#paint5_radial_2041_20915)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: -688.207,
					y: -665.085,
					width: 2312.15,
					height: 2312.15,
					rx: 202.758,
					fill: "url(#paint6_radial_2041_20915)"
				}),
				/* @__PURE__ */ _jsx("g", {
					filter: "url(#filter0_f_2041_20915)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M332.269 79.5205C427.61 65.5857 529.955 58.9474 635.415 61.1335C740.879 63.32 840.164 74.0634 932.304 91.6303C1181.14 139.194 1373.45 238.145 1455.07 359.487C1485.11 403.825 1500.54 451.302 1498.39 500.555L1497.76 509.748C1493.72 555.668 1474.57 599.622 1442.82 640.556C1413.87 678.273 1373.71 713.487 1324.86 745.49C1218.46 814.496 1070.13 868.122 897.206 897.085L879.583 899.912C791.137 913.711 696.28 921.294 597.947 921.251L-562.731 920.682C-555.117 916.842 -547.627 912.854 -540.332 908.768C-449.778 859.55 -381.835 801.379 -343.923 737.559C-322.749 702.47 -311.144 665.712 -309.492 627.788L-303.124 481.35C-301.025 433.172 -282.472 387.118 -249.996 344.176L-243.331 335.641C-175.567 251.525 -53.9261 180.537 100.207 131.747C125.361 123.802 151.173 116.517 178.104 109.822C226.917 97.6112 278.487 87.3262 332.269 79.5205ZM-562.731 920.682C-562.773 920.704 -562.8 920.732 -562.842 920.753V920.682H-562.731ZM624.641 180.916C547.937 179.326 473.793 184.155 404.945 194.217L404.464 194.27C366.531 199.776 329.351 207.166 293.394 216.161L293.098 216.232L292.839 216.303C273.833 221.028 255.509 226.189 237.378 231.916L237.341 231.898C125.505 267.327 37.9882 318.681 -10.5293 378.905L-10.6033 378.976C-36.8402 411.486 -51.9287 446.651 -53.5503 483.857L-59.9553 630.313C-62.0512 678.389 -76.7606 725.531 -104.161 770.937L-104.235 770.919C-110.286 781.07 -116.873 791.106 -124.08 801.007L598.17 801.345C674.296 801.377 747.422 795.146 815.052 783.864C939.276 763.053 1046.65 724.381 1123.97 674.307C1159.59 650.917 1188.26 625.648 1208.65 599.087L1208.94 598.696C1233.22 567.396 1247.27 533.59 1248.82 498.048C1250.36 462.5 1239.27 428.399 1217.72 396.581L1217.57 396.35C1158.86 309.079 1019.92 237.44 840.19 203.055C773.065 190.258 701.224 182.504 624.641 180.916Z",
						fill: "url(#paint7_linear_2041_20915)"
					})
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_f_2041_20915",
				x: -622.458,
				y: 1.10827,
				width: 2180.66,
				height: 979.759,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 29.808,
						result: "effect1_foregroundBlur_2041_20915"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_2041_20915",
				x1: -498.327,
				y1: 10.4764,
				x2: 905.14,
				y2: 1542.1,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: .6
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: .8
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_2041_20915",
				x1: 467.866,
				y1: 1647.06,
				x2: 467.866,
				y2: -665.085,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#EED9FA" }), /* @__PURE__ */ _jsx("stop", {
					offset: .66,
					stopColor: "#DBACF5"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint2_radial_2041_20915",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(1855.15 1909.1) rotate(-128.593) scale(3076.54 3333.89)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#DBACF5" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#DBACF5",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint3_radial_2041_20915",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(-734.45 -772.985) rotate(53.1301) scale(1695.57 1763.4)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#623875" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#623875",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint4_radial_2041_20915",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(965.827 131.08) rotate(146.478) scale(819.18 851.947)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF9903" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FF9903",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint5_radial_2041_20915",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(907.748 1016.78) rotate(-145.26) scale(760.394 790.81)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#60ADE7" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#60ADE7",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint6_radial_2041_20915",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(122.196 1089.67) rotate(-72.3872) scale(531.089 552.332)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#00C06A" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#00C06A",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint7_linear_2041_20915",
				x1: -446.886,
				y1: 28.4546,
				x2: 905.838,
				y2: 1480.44,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: .6
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: .8
				})]
			})
		] })
	]
});
export default SvgAgentCoPilotBackground;
